<div class="contact_expert h-100">
  <div class="contain d-flex flex-column justify-content-between speedo_border p-3 h-100">
    <div class="text">
      <h4 class="title">{{ 'DASHBOARD.CONTACTEXPERT.TITLE' | translate}}</h4>
      <p *ngIf="contactExpertData.description !== 'null'" [innerHTML]="contactExpertData.description | safeHtml"></p>
      <small class="mt-2">{{ 'DASHBOARD.CONTACTEXPERT.DATADESCR' | translate}} {{ contactExpertData.date }}</small>
    </div>
    <div class="ticket-btn mt-2 p-2 d-flex justify-content-around align-items-center">
      {{ 'DASHBOARD.CONTACTEXPERT.BTNDESCR' | translate}}
      <a class="p-1 px-5 btn btn-lg" (click)="contactExpertReq()">{{ 'DASHBOARD.CONTACTEXPERT.BTN' | translate }}</a>
    </div>
  </div>
</div>
